<template>
  <div class="kpb-columns" :style="`--kpb-column-gap: ${gap}; --kpb-column-count: ${columns};`">
    <slot />
  </div>
</template>

<script>
/** Layout component for splitting content into a masonry grid. */
export default {
  props: {
    columns: {
      type: Number,
      default: 2,
    },
    gap: {
      type: String,
      default: '1rem',
    },
  },
}
</script>

<style lang="scss">
.kpb-columns {
  column-count: var(--kpb-column-count);
  gap: var(--kpb-column-gap);

  @include respond-below('phone') {
    column-count: 1;
  }

  & > * {
    margin-bottom: var(--kpb-column-gap);
  }

  * {
    break-inside: avoid-column;
  }
}
</style>
